import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from "./features/app/App";
import getStore from "./features/app/store";
import * as buffer from "buffer";
import "./util/crypto-polyfill";
import Footer from "./components/footer";
import { CSSProperties } from "react";
import MosaicFooter from "./components/mosaicfooter";

const footerWrapperStyle: CSSProperties = {
  position: "sticky",
  bottom: "0",
  width: "100%",
  height: "83px",
  zIndex: 4999,
};

if (typeof window !== "undefined") {
  window.Buffer = buffer.Buffer;
  window.global = window;
}

if (window.loom && window.loom.loaded) {
  ReactDOM.render(
    <>
      <Provider store={getStore()}>
        <App />
      </Provider>
      <div id="footer" style={footerWrapperStyle}>
        <Footer />
      </div>
    </>,
    document.getElementById("root")
  );
} else {
  const elem = document.getElementById("mosaic-navigation");
  const handleLoadEvent = () => {
    ReactDOM.render(
      <>
        <Provider store={getStore()}>
          <App />
        </Provider>
        <div id="footer" style={footerWrapperStyle}>
          <Footer />
        </div>
      </>,
      document.getElementById("root")
    );
    elem?.removeEventListener("mosaic.loaded", handleLoadEvent);
  };
  elem?.addEventListener("mosaic.loaded", handleLoadEvent);
}
